/**
 * 新闻发布子页面
 * Created at 2021-10-03 14:00
 * @author teapot
 */
import { Image } from 'antd';
import { Pagination } from 'antd';
import React, { useRef, useEffect, useState, useImperativeHandle, forwardRef } from 'react';
import { withRouter } from 'react-router-dom';
import share from './image/mediaicon.png'
import { NewsItem } from '../../model/OtherModel';
import './index.css';
import { useHistory } from 'react-router';
import { DetailsParams } from '../../model/HomeModel';
import Config from '../../config';
// import NewitemAddress from './NewitemAddress';
const tot = document.querySelectorAll('.newitem-right-item').length

// 分页逻辑
const init = (i: number, p: number) => {
  const sbb = document.querySelectorAll('.newitem-right-item').length
  document.querySelectorAll('.newitem-right-item').forEach((x, i) => {
    x.classList.add('newsNone')
  })
  // console.log(p,sbb);
  if (p <= sbb)
    for (i; i <= p; i++) {
      document.querySelectorAll('.newitem-right-item')[i].classList.remove('newsNone')
    }
  else
    for (i; i < sbb; i++) {
      document.querySelectorAll('.newitem-right-item')[i].classList.remove('newsNone')
    }
}
let NewItem = ({ props, api, page, pageSize, info }: { props: NewsItem; api?: string, page?: number, pageSize?: number, info?: object }, ref: any) => {
  const itemlist = useRef(null)
  const history = useHistory();
  const NewItemRef: any = React.createRef()
  console.log(info);
  const urlParams = new URL(window.location.href);
  const pathname = urlParams?.pathname;
  useEffect(

    () => {
      init(page as number, pageSize as number)
    }

  )
  return (
    <div className='newsitem-topoffset'>
      <div className='newitem'>
        {/* <div className='newitem-left newitem-left-phone'>
        <div className='news-item-image news-item-image-flex'>
          <Image src={`${Config.MAIN_URL}${props.img}`} preview={false} />
        </div>
        <div className='news-item-image-title news-item-image-title-phone'>
          {props.title}
        </div>
        {props.time}
      </div> */}
        <div className='newitem-right'>
          {/* {  console.log( localStorage.getItem("i18nextLng"))} */}
          {props.articles &&
            props.articles.map((value, i) => {
              return (
                <div className='newitem-right-item newsNone' ref={itemlist} key={i}>
                  <div className='news-time'>  {props.time}</div>
                  <div className='news-title'> {value.author ? value.author : props.title}</div>
                  {/* <div className='news-item-image-title news-item-image-title-phone'>
                    {value.author}
                  </div> */}
                  {/* <div className='vline'></div> */}
                  <div className='tinktank-item-middle-content tinktank-item-middle-content-phone news-height' onClick={() => {
                    if (value.url) {
                      window.location.href = value.url;
                    } else if (value.uuid) {
                      let path = window.btoa(
                        JSON.stringify({
                          url: api,
                          uuid: value.uuid,
                          methods: 'get',
                          pdf: value.pdf,
                          info: info,
                          newstime: encodeURIComponent(props.time)
                        })
                      );
                      history.push(`/newsroom/press-release/date_pressreleasetitle_tc/${path}`,
                        {
                          url: api,
                          uuid: value.uuid,
                          methods: 'get',
                          pdf: value.pdf,
                          info: info,
                          newstime:props.time
                        });
                    }
                  }}>
                    {value.article}
                  </div>
                  {value.pdf ?  <div className='newx-shell '><div className='pdfload ' onClick={()=>{window.location.href=`${Config.MAIN_URL}${value.pdf}`}}> </div> <a  className='media-icon' href={`${Config.MAIN_URL}${value.pdf}`}></a>  </div> : null}
                  {/* <a className='media-icon' href="#">?</a> */}
                  {/* <div className='news-icon' >
                    <a href="#">sb</a>
                    <Image preview={false} src={share} width={'30px'} />
                    </div> */}
                </div>
              );
            })}
        </div>
      </div>

    </div>

  );

};
export default forwardRef(NewItem);
